export const environment = {
    production: false,
    configuration: 'develop',
    apiUrl: 'https://develop.tiendaonemall.com.co/api',
    smsUrl: 'https://api.messaging-service.com',
    businessName: 'ONE MALL'
};